import React from 'react';
import { Link } from 'react-router-dom';
import ISeeYouStillImage from '../assets/images/ISeeYouStill.jpg';
import BreatheStillImage from '../assets/images/BreatheStill.jpg';
import PleaseHoldStillImage from '../assets/images/PleaseHoldStill.jpg';
import ToWhomILetGoStillImage from '../assets/images/ToWhomILetGoStill.jpg';
import OffTheDeckStillImage from '../assets/images/OfftheDeckStill.png';
import IWantMyVmagPhoto from '../assets/images/IWantMyVMAGPhoto.png';
import './NarrativePage.css';

function NarrativePage() {
  return (
    <div className="films-container">
      <div className="films-row">
        <Link to="/off-the-deck" className="films-image-link films-off-the-deck">
          <div className="films-overlay-container">
            <img src={OffTheDeckStillImage} alt="Off the Deck Still" className="films-image" />
            <div className="films-title">Off the Deck</div>
          </div>
        </Link>
        <Link to="/to-whom-i-let-go" className="films-image-link">
          <div className="films-overlay-container">
            <img src={ToWhomILetGoStillImage} alt="To Whom I Let Go Still" className="films-image" />
            <div className="films-title">To Whom I Let Go</div>
          </div>
        </Link>
      </div>
      <div className="films-row">
        <Link to="/please-hold" className="films-image-link">
          <div className="films-overlay-container">
            <img src={PleaseHoldStillImage} alt="Please Hold Still" className="films-image" />
            <div className="films-title">Please Hold</div>
          </div>
        </Link>
        <Link to="/breathe" className="films-image-link">
          <div className="films-overlay-container">
            <img src={BreatheStillImage} alt="Breathe Still" className="films-image" />
            <div className="films-title">Breathe</div>
          </div>
        </Link>
      </div>
      <div className="films-row">
        <Link to="/i-see-you" className="films-image-link">
          <div className="films-overlay-container">
            <img src={ISeeYouStillImage} alt="I See You Still" className="films-image" />
            <div className="films-title">I See You</div>
          </div>
        </Link>
        <Link to="/i-want-my-vmag" className="films-image-link">
          <div className="films-overlay-container">
            <img src={IWantMyVmagPhoto} alt="I Want My Vmag" className="films-image" />
            <div className="films-title">I Want My Vmag</div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default NarrativePage;
